import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vias-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    // event ekle
    window.addEventListener('storage', this.sessionStorage_transfer, false);
    if (!sessionStorage.length) {
      // calistirmak icin ekle cikart...
      localStorage.setItem('getSessionStorage', '1');
      localStorage.removeItem('getSessionStorage');
    }
  }
  constructor(translate: TranslateService) {
    translate.addLangs(['tr', 'en', 'fr']);
    translate.setDefaultLang('tr');

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/tr|en|fr/) ? browserLang : 'tr');
  }

  private sessionStorage_transfer(event): void {
    // tslint:disable-next-line: deprecation
    if (!event) { event = window.event; } // salak ie icin
    if (!event.newValue){ return; }// yenibisi yoksa calisma
    if (event.key === 'getSessionStorage') {
      // tabdan gonderilen
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      // hemen ekle ve cikart... timeout gerekebilir mi ?
      localStorage.removeItem('sessionStorage');
    } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
      // baska tab da acilan
      const data = JSON.parse(event.newValue);
      for (const key in data) {
        if (key){
          sessionStorage.setItem(key, data[key]);
        }
      }
    }
  }
}
